import { z } from 'zod'

export const trashStatsSchema = z.object({
  totalTrashItems: z.number().int().nonnegative(),
  expiredItems: z.number().int().nonnegative(),
  retentionDays: z.number().int().positive(),
})

export const trashPageMetaSchema = z.object({
  totalElements: z.number().int().nonnegative(),
  totalPages: z.number().int().nonnegative(),
  number: z.number().int().nonnegative(),
  size: z.number().int().positive(),
  first: z.boolean(),
  last: z.boolean(),
  empty: z.boolean(),
})

export const cleanupResultSchema = z.object({
  message: z.string(),
  durationMs: z.number().optional(),
  success: z.boolean().optional(),
  errorMessage: z.string().nullable().optional(),
})

export type TrashStats = z.infer<typeof trashStatsSchema>
export type TrashPageMeta = z.infer<typeof trashPageMetaSchema>
export type CleanupResult = z.infer<typeof cleanupResultSchema>
